import { useTheme } from '@chakra-ui/react';
import React from 'react';
import CarouselForComponents from '../carouselCustom/carouselCustom';
import { StarIcon } from '@chakra-ui/icons';
import { useAppContext } from '../../App';

export default function Qualifications() {
  const theme = useTheme();
  const {isMobile} = useAppContext();
  const style = styles(theme, isMobile);
  const descripcion1 = 'Los contenidos están muy bien explicados y actualizados. Me sorprendió la claridad con la que se abordan temas complejos. Se nota que hay un gran trabajo detrás de cada curso.'
  const descripcion2 = 'Desde el primer día sentí un acompañamiento real. Me respondieron rápido cada vez que tuve dudas y me ayudaron a organizar mis tiempos para terminar el curso sin atrasarme.'
  const descripcion3 = 'La certificación que obtuve me sirvió para actualizar mi currículum y ya la pude presentar en varias entrevistas. Me gusta que sea una institución reconocida y que respalde lo aprendido.'
  const descripcion4 = 'Probé con otras plataformas antes, pero acá encontré algo distinto: hay calidez, compromiso y un enfoque en lo que realmente te ayuda a crecer. No es solo un curso más, es una experiencia completa.'
  const descripcion5 = 'Lo que más valoro es que no estás solo. En todo momento hubo alguien para responderme, orientarme y motivarme a seguir.'
  const descripcion6 = 'Hice cursos en otras academias, pero siempre sentí que era un número más. Acá te llaman por tu nombre, te preguntan cómo vas, y eso marca la diferencia.'
  const descripcion7 = 'Pude estudiar a mi ritmo, sin horarios fijos, y eso me permitió organizarme sin dejar de trabajar. Lo recomiendo para quienes tienen poco tiempo.'

  const QualificationCard = ({ name, description, ratingQty }) => {
    return (
      <div style={style.cardContainer}>
        <div style={style.cardRating}>
          {Array(ratingQty)
            .fill(null)
            .map((_, i) => (
              <StarIcon key={`star-rating-${i}`}/>
            ))}
        </div>
        <p style={style.cardDescription}>{description}</p>
        <p style={style.cardName}>- {name} -</p>
      </div>
    );
  };
  return (
    <div style={style.container} className="sansation-bold">
      <div style={style.textContainer}>
        {/* <p style={style.doubletips}>"</p> */}
        <p style={style.blueTitle}>CONOCÉ CÓMO</p>
        <p style={style.whiteTitle}>NOS CALIFICARON</p>
        <p style={style.whiteTitle}>OTROS ESTUDIANTES</p>
      </div>
      <CarouselForComponents qtyPerView={isMobile? 1 : 4} customStyles={style.carousel}>
        <QualificationCard name={'Mariela Gutiérrez'} description={descripcion1} ratingQty={5}/>
        <QualificationCard name={'Marina Torres'} description={descripcion2} ratingQty={5}/>
        <QualificationCard name={'Carlos Leiva'} description={descripcion3} ratingQty={5}/>
        <QualificationCard name={'Natalia Correa'} description={descripcion4} ratingQty={5}/>
        <QualificationCard name={'Diego Ramírez'} description={descripcion5} ratingQty={5}/>
        <QualificationCard name={'Valeria Méndez'} description={descripcion6} ratingQty={5}/>
        <QualificationCard name={'Ezequiel Duarte'} description={descripcion7} ratingQty={5}/>
      </CarouselForComponents>
    </div>
  );
}

const styles = (theme, isMobile) => ({
  container: {
    display: "flex",
    flexDirection: isMobile? "column" : "row",
    justifyContent: "space-between",
    alignItems: "center",
    color: theme.color.text.primary,
    padding: "2vw",
    paddingLeft: "5vw",
    paddingRight: "5vw",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "2vh",
  },
  doubletips: {
    fontSize: "1rem",
    color: theme.color.text.primary,
  },
  blueTitle: {
    fontSize: isMobile? "1.8rem" : "2rem",
    textAlign: isMobile? "center" : "left",
    color: theme.color.text.secondary,
  },
  whiteTitle: {
    fontSize: isMobile? "1.8rem" : "2rem",
    textAlign: isMobile? "center" : "left",
    color: theme.color.text.primary,
  },
  carousel: {
    width: "75%",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  cardRating: {
    display: "flex",
    flexDirection: "row",
    marginBottom: "0.6rem",
  },
  cardDescription: {
    textAlign: "center",
    fontSize: "0.9rem",
    fontWeight: "300",
  },
  cardName: {
    marginTop: "0.5rem",
  }
});
